export interface Program {
  id: string;
  slug: string;
  name: string;
  description: string;
  image: string;
  presenter: string;
  category: string;
  department: string;
  broadcastDays: string[];
  broadcastTime: string;
  duration: string;
  featured: boolean;
  tags: string[];
}

export const programs: Program[] = [
  {
    id: "1",
    slug: "ltv-news-hour",
    name: "L+TV News Hour",
    description: "Comprehensive daily news coverage covering local, national, and international stories that matter to Cameroonians. Hosted by experienced journalists with in-depth analysis and field reports.",
    image: "https://readdy.ai/api/search-image?query=Professional%20television%20news%20studio%20with%20anchor%20desk%2C%20multiple%20monitors%2C%20modern%20broadcast%20setup%2C%20warm%20lighting%2C%20editorial%20photography%20style&width=640&height=360&seq=prog-1&orientation=landscape",
    presenter: "L+TV News Team",
    category: "News",
    department: "News Department",
    broadcastDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    broadcastTime: "18:00",
    duration: "60 min",
    featured: true,
    tags: ["news", "daily", "broadcast"],
  },
  {
    id: "2",
    slug: "evening-talk",
    name: "The Evening Talk",
    description: "A thought-provoking talk show featuring interviews with community leaders, politicians, business figures, and cultural personalities. Engaging discussions on topics that shape Cameroon and the world.",
    image: "https://readdy.ai/api/search-image?query=Television%20talk%20show%20set%20with%20two%20chairs%20and%20modern%20lighting%2C%20interview%20setup%2C%20warm%20ambiance%2C%20editorial%20photography%20style&width=640&height=360&seq=prog-2&orientation=landscape",
    presenter: "Patrice Mballa",
    category: "Talk Show",
    department: "Entertainment & Culture Department",
    broadcastDays: ["Monday", "Wednesday", "Friday"],
    broadcastTime: "20:00",
    duration: "45 min",
    featured: true,
    tags: ["talk", "interview", "discussion"],
  },
  {
    id: "3",
    slug: "sports-central",
    name: "Sports Central",
    description: "Your go-to destination for sports coverage in Cameroon and beyond. Match highlights, analysis, interviews with athletes, and exclusive coverage of local and international sporting events.",
    image: "https://readdy.ai/api/search-image?query=Sports%20television%20studio%20with%20presenter%20desk%20and%20sports%20graphics%20background%2C%20modern%20broadcast%20setup%2C%20editorial%20photography%20style&width=640&height=360&seq=prog-3&orientation=landscape",
    presenter: "Jean-Pierre Essomba",
    category: "Sports",
    department: "News Department",
    broadcastDays: ["Tuesday", "Thursday", "Saturday"],
    broadcastTime: "19:30",
    duration: "30 min",
    featured: true,
    tags: ["sports", "football", "athletics"],
  },
  {
    id: "4",
    slug: "youth-vibe",
    name: "Youth Vibe",
    description: "A vibrant youth-oriented program covering music, fashion, technology, entrepreneurship, and lifestyle. Designed to inspire and empower the next generation of Cameroonian leaders.",
    image: "https://readdy.ai/api/search-image?query=Young%20people%20in%20modern%20television%20studio%2C%20colorful%20youth%20program%20set%20design%2C%20warm%20lighting%2C%20editorial%20photography%20style&width=640&height=360&seq=prog-4&orientation=landscape",
    presenter: "Sarah Ndongo",
    category: "Youth",
    department: "Entertainment & Culture Department",
    broadcastDays: ["Saturday", "Sunday"],
    broadcastTime: "14:00",
    duration: "60 min",
    featured: true,
    tags: ["youth", "music", "lifestyle"],
  },
  {
    id: "5",
    slug: "faith-community",
    name: "Faith & Community",
    description: "A spiritual program dedicated to biblical teaching, community discussions, and religious events. Promoting unity, faith, and positive values across communities in Cameroon.",
    image: "https://readdy.ai/api/search-image?query=Serene%20church%20interior%20with%20warm%20candlelight%20and%20stained%20glass%20windows%2C%20peaceful%20religious%20atmosphere%2C%20editorial%20photography%20style&width=640&height=360&seq=prog-5&orientation=landscape",
    presenter: "Pastor Thomas Nkolo",
    category: "Religion",
    department: "Religion & Community",
    broadcastDays: ["Sunday"],
    broadcastTime: "09:00",
    duration: "90 min",
    featured: true,
    tags: ["religion", "faith", "community"],
  },
  {
    id: "6",
    slug: "cultural-roots",
    name: "Cultural Roots",
    description: "A deep dive into Cameroon's rich cultural heritage, exploring traditions, arts, music, cuisine, and historical sites. Celebrating the diversity that makes Cameroon unique.",
    image: "https://readdy.ai/api/search-image?query=Traditional%20African%20cultural%20artifacts%20and%20textiles%20displayed%20in%20artistic%20arrangement%2C%20warm%20lighting%2C%20editorial%20photography%20style&width=640&height=360&seq=prog-6&orientation=landscape",
    presenter: "Amina Bello",
    category: "Culture",
    department: "Entertainment & Culture Department",
    broadcastDays: ["Friday"],
    broadcastTime: "21:00",
    duration: "45 min",
    featured: false,
    tags: ["culture", "heritage", "tradition"],
  },
];